<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" width="400px">
            <el-upload
                    :on-success="uploadSuccess"
                    drag :action="hostUrl + '/traceability/uploadTraceabilityExcel'"
                    multiple
                    :before-upload="beforeAvatarUpload"
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件，且不超过50Mb</div>
            </el-upload>
        </el-dialog>
    </div>
</template>
<script>

    export default {
        data() {
            return {
                hostUrl: config.hostUrl,
                dialogVisible: false,
            }
        },
        props: {
            success: {
                type: Function,
                require: true
            },
        },
        mounted() {
        },
        methods: {
            beforeAvatarUpload(file) {
                const isLt50MB = file.size / 1024 / 1024 < 50;
                if (!isLt50MB) {
                    this.$message.error('上传文件大小不能超过 50MB!');
                }
                return isLt50MB;
            },
            uploadSuccess(res, file) {
                const h = this.$createElement;
                let _this = this;
                if (res.success === false) {
                    this.$notify({
                        title: '文件解析失败',
                        message: h('i', {style: 'color: red'}, res.msg),
                        duration: 0
                    });
                }
                _this.closeDialog()
                if (this.success) {
                    this.success();
                }
            },
            openDialog() {
                this.dialogVisible = true;
            },
            closeDialog() {
                this.dialogVisible = false;
            }
        },


    }

</script>
